import { gql } from 'graphql.macro';
import {
    millingBatchFragment,
    millingJobFragment,
    millingJobTypesFragment,
    millingMaterialFragment,
} from 'apollo/fragments';

export const millingMaterialsTemplate = gql`
    query millingMaterials {
        millingMaterials {
            ...millingMaterialFields
        }
    }
    ${millingMaterialFragment}
`;

export const millingJobTypesTemplate = gql`
    query millingJobTypes {
        millingJobTypes {
            ...millingJobTypesFields
        }
    }
    ${millingJobTypesFragment}
`;

export const millingJobsTemplate = gql`
    query millingJobs($orderId: MongoDbObjectId!) {
        millingJobs(orderId: $orderId) {
            ...millingJobFields
            order {
                _id
                orderId
                internalOrderId
            }
        }
    }
    ${millingJobFragment}
`;

export const millingTasksTemplate = gql`
    query millingTasks($filters: MillingFilters) {
        millingTasks(filters: $filters) {
            ...millingJobFields
            order {
                _id
                orderId
                internalOrderId
            }
        }
    }
    ${millingJobFragment}
`;

export const millingBatchesTemplate = gql`
    query millingBatches($limit: Int, $offset: Int, $filters: MillingFilters) {
        millingBatches(limit: $limit, offset: $offset, filters: $filters) {
            ...millingBatchFields
        }
    }
    ${millingBatchFragment}
`;
